










import { Vue, Component } from "vue-property-decorator";
import api, { settingStorageApi } from "@/getinfo-api";
import { getCurrentCompanyId } from "@/plugins/roles";

@Component({ components: {} })
export default class StudentLimitSettings extends Vue {
  get companyId(): string {
    return getCurrentCompanyId();
  }

  get isBlocked() {
    return this.$store.getters.IS_BLOCK_ADD_STUDENTS;
  }

  async getStudentLimit() {
    if (this.companyId) {
      settingStorageApi.Company.getCompanySettings(this.companyId, [
        "studentLimit"
      ]).then(res => {
        //@ts-ignore
        this.$store.state.studentLimit = +res.data[0]?.value?.amount;
      });
    }
  }
  async getStudentActive() {
    if (this.companyId) {
      api.CourseApi.listenersCountGlobal(this.companyId).then(res => {
        this.$store.state.studentAmount = +res.data;
      });
    }
  }

  created() {
    this.getStudentActive();
    this.getStudentLimit();
  }
}
